import type { TelephonyAccountView } from '@/shared/api/__generated__'
import { cn } from '@/shared/lib'
import { CardLink } from '@/shared/ui/card'
import { Chip } from '@/shared/ui/chip'
import { StatusBadge } from '@/shared/ui/status-badge'
import { accountStatus } from '../model/statuses'

interface AccountCardProps {
  account: TelephonyAccountView
  active?: boolean
}

export function AccountCard({ account, active = false }: AccountCardProps) {
  return (
    <CardLink
      to="/telephony/accounts/$accountId"
      params={{ accountId: account.id }}
      active={active}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="truncate text-body-sm font-medium">{account.username}</span>
        <StatusBadge {...accountStatus(account.status)} />
      </div>
      <p className={cn('mt-0.5 truncate text-body-sm', active ? 'text-white/80' : 'text-muted')}>
        {account.provider_profile_id}
        {account.pool_id ? ` · ${account.pool_id}` : ' · без пула'}
      </p>
      <div
        className={cn(
          'mt-3 flex items-center justify-between rounded-control px-3 py-2',
          active ? 'bg-black/25' : 'bg-raise',
        )}
      >
        <span className={cn('text-caption', active ? 'text-white/70' : 'text-muted')}>
          {account.channels} каналов · DID×{(account.dids ?? []).length}
        </span>
        {account.owner_type === 'client' && <Chip tone="accent">BYOC</Chip>}
      </div>
    </CardLink>
  )
}
